<template>
  <div class="advertisementPage">
     <!-- <header-logged-in></header-logged-in> -->
    <!-- <banner-search></banner-search> -->

    <div  class="content-holder">
      <div class="container section-holder">
        <div v-if ="!isLoggedIn" class="noticemsg"><span>{{$t('login.alerts.logout_success')}}</span></div>
      </div>
      <trendingCourses></trendingCourses>
      <!-- <courseCards v-if="isLoggedIn"></courseCards>
      <libraryCards></libraryCards>
      <newVideoCards></newVideoCards> -->
    </div>
    <!-- <footerArea></footerArea> -->
 </div>
</template>

<script>
import { EventBus } from '@/main.js'
import newVideoCards from '../home/newVideoCards'
import bannerSearch from '../home/bannerSearch.vue'
import courseCards from '../home/courseCards'
import libraryCards from '../home/libraryCards'
import trendingCourses from '../home/trendingCourses'
export default {
  name: 'advertisementPage',
  components: {
    newVideoCards,
    bannerSearch,
    courseCards,
    libraryCards,
    trendingCourses
  },
  data () {
    return {
    }
  },
  methods: {
    checkTokenValidity () {
      var home = this
      var token = window.MKCLAPI.getToken()
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData')
          window.MKCLAPI.removeToken()
        })
      }
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  mounted () {
    this.checkTokenValidity()
    EventBus.$emit('showNav', true)
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/advertisement/advertisementPage.vue?6aa9131b